import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Spinner } from "@/components/common";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/layout/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Anagrafica from "@/pages/Anagrafica";
import Tesseramenti from "@/pages/Tesseramenti";
import Certificati from "@/pages/Certificati";
import Corsi from "@/pages/Corsi";
import Presenze from "@/pages/Presenze";
import Impianti from "@/pages/Impianti";
import Pagamenti from "@/pages/Pagamenti";
import PrimaNota from "@/pages/PrimaNota";
import Documenti from "@/pages/Documenti";
import Comunicazioni from "@/pages/Comunicazioni";
import Utenti from "@/pages/Utenti";
import Portale from "@/pages/Portale";
import SuperAdmin from "@/pages/SuperAdmin";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center"><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route path="/app" element={<Protected><AppLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="portale" element={<Portale />} />
        <Route path="anagrafica" element={<Anagrafica />} />
        <Route path="tesseramenti" element={<Tesseramenti />} />
        <Route path="certificati" element={<Certificati />} />
        <Route path="corsi" element={<Corsi />} />
        <Route path="presenze" element={<Presenze />} />
        <Route path="impianti" element={<Impianti />} />
        <Route path="pagamenti" element={<Pagamenti />} />
        <Route path="contabilita" element={<PrimaNota />} />
        <Route path="documenti" element={<Documenti />} />
        <Route path="comunicazioni" element={<Comunicazioni />} />
        <Route path="utenti" element={<Utenti />} />
        <Route path="piattaforma" element={<SuperAdmin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
